const PermissionList = () => {

    return (
        <> 
           <div className="search role-bx">
                <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3"></path></svg>
                <input id="mainSearch" placeholder="Search people…" oninput="renderTab()"/>
            </div>
<div id="listArea" className="list role_list">
  <div className="cat-role">Contacts</div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Contact.View</div>
      <div className="desc">View contacts in own hierarchy</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">6</span>
      </button>
      <button className="stat ro"  title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">5</span>
      </button>
    </div>
  </div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Contact.Create</div>
      <div className="desc">Add and edit contacts</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">5</span>
      </button>
      <button className="stat ro"  title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">4</span>
      </button>
    </div>
  </div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Contact.All</div>
      <div className="desc">See every contact across the org</div>
    </div>
    <div className="stats">
      <button className="stat">
        <span className="lbl">People</span>
        <span className="n">3</span>
      </button>
      <button className="stat ro"  title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">3</span>
      </button>
    </div>
  </div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Contact.Export</div>
      <div className="desc">Export contact lists</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">2</span>
      </button>
      <button className="stat ro"  title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">2</span>
      </button>
    </div>
  </div>

  <div className="cat-role">Deals</div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Deal.Manage</div>
      <div className="desc">Create, edit and move deals</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">5</span>
      </button>
      <button className="stat ro" title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">4</span>
      </button>
    </div>
  </div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Deal.Delete</div>
      <div className="desc">Delete deals</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">2</span>
      </button>
      <button className="stat ro"  title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">2</span>
      </button>
    </div>
  </div>

  <div className="cat-role">Bookings</div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Booking.Create</div>
      <div className="desc">Create bookings and pricing</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">5</span>
      </button>
      <button className="stat ro"  title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">5</span>
      </button>
    </div>
  </div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Booking.Registry</div>
      <div className="desc">Update registry &amp; KYC status</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">3</span>
      </button>
      <button className="stat ro"  title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">3</span>
      </button>
    </div>
  </div>

  <div className="cat-role">Projects</div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Project.Manage</div>
      <div className="desc">Manage projects, towers &amp; units</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">1</span>
      </button>
      <button className="stat ro"  title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">1</span>
      </button>
    </div>
  </div>

  <div className="cat-role">Reports</div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Report.View</div>
      <div className="desc">View dashboards &amp; reports</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">6</span>
      </button>
      <button className="stat ro"  title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">5</span>
      </button>
    </div>
  </div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Report.Export</div>
      <div className="desc">Export reports to Excel/PDF</div>
    </div>
    <div className="stats">
      <button className="stat">
        <span className="lbl">People</span>
        <span className="n">3</span>
      </button>
      <button className="stat ro"  title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">3</span>
      </button>
    </div>
  </div>

  <div className="cat-role">Admin</div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Admin.Access</div>
      <div className="desc">Manage users, roles &amp; settings</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">1</span>
      </button>
      <button className="stat ro"  title="Roles are managed from the Roles tab">
        <span className="lbl">Roles</span>
        <span className="n">1</span>
      </button>
    </div>
  </div>
</div>

        </>
    )
}

export default PermissionList;